import { graphql } from "@server/gql";

export const fragments = graphql(/* GraphQL */ `
  fragment resetPasswordPageEntry on Entry {
    __typename
    sys {
      id
    }
  }
`);

export default graphql(/* GraphQL */ `
  query ResetPasswordPage($id: String!, $locale: String!, $preview: Boolean) {
    page(locale: $locale, id: $id, preview: $preview) {
      ...resetPasswordPageEntry
      title
      ingress {
        json
      }
      dictionary {
        listCollection {
          items {
            key
            name
            value
          }
        }
      }
    }
  }
`);
